module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/driver-detail/driver-detail.component.css
// module id = ./src/app/driver-detail/driver-detail.component.css
// module chunks = main